export enum EventPatternToClientId {
  'event1',
  'event2',
  'event3',
}
